import * as constants from "../../assets/constants";
import {baseApi} from "../BaseApi";

class StandsApi extends baseApi {

    getOne = async (id) => {
        return await this.get(`?app=stands&act=getOne&id=${id}`)
    }

    getList = async (data) => {
        return await this.post('?app=stands&act=getList', data)
    }

    save = async (data) => {
        return await this.post('?app=stands&act=save', {data: JSON.stringify(data)})
    }

    delete = async (id) => {
        return await this.post('?app=stands&act=setDeleted', {id})
    }
}

export default new StandsApi(constants.DEBUG ? constants.base_url_stage : constants.base_url_prod);
